import {createBrowserHistory} from 'history';

export const history = createBrowserHistory({
    forceRefresh: false
});

export default history;